module.exports = __webpack_public_path__ + "media/images/arrow-ee78e609c1cc2ac09463908842a7578d.gif";